import React from 'react';
import './Camera.scss';

function Camera() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 23" className="camera-icon"><g fill="none" stroke="#010101"><g transform="translate(0 3)"><rect width="25" height="20" rx="3" stroke="none"/><rect x=".5" y=".5" width="24" height="19" rx="2.5"/></g><path d="M.5 13.5h8"/><g transform="translate(8 8)"><circle cx="5" cy="5" r="5" stroke="none"/><circle cx="5" cy="5" r="4.5"/></g><g transform="translate(11 11)"><circle cx="2" cy="2" r="2" stroke="none"/><circle cx="2" cy="2" r="1.5"/></g><path d="M17.5 6.5h5"/><path stroke="none" d="M5 0h4v4H5z"/><path d="M5.5.5h3v3h-3zM17.5 13.5h7.112"/></g></svg>
    )
}

export default Camera;